const CY = {
  ibanLength: 28,
};
export { CY };
